import React, { ReactNode } from 'react';

interface NavItemProps {
  children: ReactNode;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

const NavItem: React.FC<NavItemProps> = ({ children, onClick }) => {
  return (
    <a 
      role="button"
      className="text-sm font-medium bg-gradient-to-r from-blue-300 via-blue-400 to-blue-200 bg-clip-text text-transparent hover:opacity-80 transition-opacity py-1"
      onClick={onClick ? onClick : (e) => e.preventDefault()}
      style={{
        position: 'relative',
        textDecoration: 'none',
        cursor: 'pointer'
      }}
      onMouseEnter={(e) => {
        const underline = document.createElement('div');
        underline.style.position = 'absolute';
        underline.style.bottom = '0';
        underline.style.left = '0';
        underline.style.width = '100%';
        underline.style.height = '2px';
        underline.style.background = 'linear-gradient(to right, transparent, #60a5fa, transparent)';
        underline.style.opacity = '0';
        underline.style.transition = 'opacity 0.3s ease';
        underline.className = 'nav-underline';
        e.currentTarget.appendChild(underline);
        setTimeout(() => {
          underline.style.opacity = '1';
        }, 10);
      }}
      onMouseLeave={(e) => {
        const underline = e.currentTarget.querySelector('.nav-underline');
        if (underline) {
          (underline as HTMLElement).style.opacity = '0';
          setTimeout(() => {
            underline.remove();
          }, 300);
        }
      }}
    >
      {children}
    </a>
  );
};

export default NavItem; 